module.exports = require("swa-bootstrap-corporate-landing-home-page/landing-page/ezrez-keys-home-page");